import { makeActionCreator } from '../../config/store/utils'
import { RECORDS_PER_PAGE, SEARCH_FILTER_NAME, SEARCH_FILTER_RUT } from '../../config/settings/constant'
import { getSearchBuyerByOrgLegalName, getSearchBuyerByRut } from '../../services/buyers'

export const SEARCH_BUYER = 'SEARCH_BUYER'
export const SEARCH_BUYER_ERROR = 'SEARCH_BUYER_ERROR'
export const SEARCH_BUYER_SUCCESS = 'SEARCH_BUYER_SUCCESS'
export const onSearchBuyer = makeActionCreator(SEARCH_BUYER)
export const onSearchBuyerError = makeActionCreator(SEARCH_BUYER_ERROR, 'payload')
export const onSearchBuyerSuccess = makeActionCreator(SEARCH_BUYER_SUCCESS, 'payload')
export const onSearchBuyerThunk = payload => async dispatch => {
  dispatch(onSearchBuyer())
  if (payload.dni === '' && payload.orgLegalName === '') {
    return dispatch(
      onSearchBuyerError({
        code: '403',
        message: 'Ingresa un valor antes de realizar la búsqueda'
      })
    )
  } else {
    try {
      let response
      switch (payload.searchType) {
        case SEARCH_FILTER_RUT:
          response = await getSearchBuyerByRut({
            actionType: SEARCH_BUYER,
            dni: payload.dni,
            page: 0,
            size: RECORDS_PER_PAGE
          })
          break
        case SEARCH_FILTER_NAME:
          response = await getSearchBuyerByOrgLegalName({
            actionType: SEARCH_BUYER,
            orgLegalName: payload.orgLegalName,
            page: 0,
            size: RECORDS_PER_PAGE
          })
          break
      }

      // FIXME: https://github.com/babel/babel-eslint/issues/799
      const buyersView = response.data?.payload?.respuesta.map(buyer => {
        return {
          dni: buyer.rut,
          orgLegalName: buyer.razonSocial
        }
      })

      // We set the data view for the container component and the page obtained to buyers dictionary collection
      return dispatch(
        onSearchBuyerSuccess({
          buyers: {
            1: buyersView
          },
          buyersView,
          totalRecordsCount: response.data?.payload?.totalResultados,
          totalPages: response.data?.payload?.totalPaginas,
          searchOption: {
            ...payload
          }
        })
      )
    } catch (error) {
      if (error.code === 400) {
        return dispatch(
          onSearchBuyerError({ code: error.code, message: error.originalError.response?.data?.errores[0]?.descripcion })
        )
      }
      if (error.code === 401) {
        return dispatch(onSearchBuyerError({ code: error.code, message: 'No esta autenticado.' }))
      }

      return dispatch(
        onSearchBuyerError({
          code: error.code,
          title: 'Lo sentimos, estamos presentando problemas con nuestro servidor',
          message:
            'En estos momentos tenemos problemas para disponibilizar la información. Por favor, consulta en unos minutos más.'
        })
      )
    }
  }
}

export const SEARCH_BUYER_PAGE = 'SEARCH_BUYER_PAGE'
export const SEARCH_BUYER_PAGE_ERROR = 'SEARCH_BUYER_PAGE_ERROR'
export const SEARCH_BUYER_PAGE_SUCCESS = 'SEARCH_BUYER_PAGE_SUCCESS'
export const onSearchBuyerPage = makeActionCreator(SEARCH_BUYER_PAGE)
export const onSearchBuyerPageError = makeActionCreator(SEARCH_BUYER_PAGE_ERROR, 'payload')
export const onSearchBuyerPageSuccess = makeActionCreator(SEARCH_BUYER_PAGE_SUCCESS, 'payload')
export const onSearchBuyerPageThunk = payload => async (dispatch, getState) => {
  dispatch(onSearchBuyerPage())

  try {
    // Getting the buyers pages and options used in previous search
    const {
      searchBuyer: { buyers, searchOption }
    } = getState()
    const page = payload.page || 1

    // Validate if the requested page is in the redux store
    if (buyers[page]) {
      return dispatch(
        onSearchBuyerPageSuccess({
          buyers,
          buyersView: buyers[page],
          page
        })
      )
    }

    // otherwise we make the API call to get some specific page using the options in the previous search
    let response
    switch (searchOption.searchType) {
      case SEARCH_FILTER_RUT:
        response = await getSearchBuyerByRut({
          actionType: SEARCH_BUYER_PAGE,
          dni: searchOption.dni,
          page: page - 1,
          size: RECORDS_PER_PAGE
        })
        break
      case SEARCH_FILTER_NAME:
        response = await getSearchBuyerByOrgLegalName({
          actionType: SEARCH_BUYER_PAGE,
          orgLegalName: searchOption.orgLegalName,
          page: page - 1,
          size: RECORDS_PER_PAGE
        })
        break
    }

    // FIXME: https://github.com/babel/babel-eslint/issues/799
    const buyersView = response.data?.payload?.respuesta.map(buyer => {
      return {
        dni: buyer.rut,
        orgLegalName: buyer.razonSocial
      }
    })

    // We set the data view for the container component and add the page obtained to sellers dictionary collection
    return dispatch(
      onSearchBuyerPageSuccess({
        buyers: {
          ...buyers,
          [page]: buyersView
        },
        buyersView,
        page
      })
    )
  } catch (error) {
    if (error.code === 400) {
      return dispatch(
        onSearchBuyerPageError({
          code: error.code,
          message: error.originalError.response?.data?.errores[0]?.descripcion
        })
      )
    }
    if (error.code === 401) {
      return dispatch(onSearchBuyerPageError({ code: error.code, message: 'No esta autenticado.' }))
    }

    return dispatch(
      onSearchBuyerPageError({
        code: error.code,
        title: 'Lo sentimos, estamos presentando problemas con nuestro servidor',
        message:
          'En estos momentos tenemos problemas para disponibilizar la información. Por favor, consulta en unos minutos más.'
      })
    )
  }
}
